import React, { forwardRef, ForwardRefRenderFunction } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { DocumentationLogFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelAdvisor } from "wint-api-client/dist/types";
import { DocumentationLogCreateFormContainerProps } from "models/propTypes/advisorPropTypes";
//#endregion
//#region components
import DocumentationLogCreateForm from "./createForm";
import { useDocumentationLogService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const DocumentationLogCreateFormContainer: ForwardRefRenderFunction<
  FormHandles,
  DocumentationLogCreateFormContainerProps
> = (props, ref) => {
  const documentationLogService = useDocumentationLogService();
  const companyId = useSelector((store: AppState) => store.auth.selectedCompany.id);
  const personId = useSelector((store: AppState) => store.auth.loggedInUser.personId);

  const { onFormValidationChange } = props;

  const documentationLog = {
    subject: "",
    message: "",
    isSupportTicket: false,
    attachments: [],
  } as DocumentationLogFormTypes.Create;

  const validationSchema = Yup.object<DocumentationLogFormTypes.Create>({
    subject: Yup.string().required(TranslationKeys.Validations.Required),
    message: Yup.string().required(TranslationKeys.Validations.Required),
    attachments: Yup.array(),
  });

  const handleFormSubmit = async (values: DocumentationLogFormTypes.Create) => {
    return documentationLogService.createLog({
      companyId: companyId,
      authorId: personId,
      subject: values.subject,
      message: values.message,
      createCustomerCase: values.isSupportTicket,
      attachmentReferences: values.attachments.map(
        (a) =>
          ({
            name: a.fileName,
            contentType: a.contentType,
            data: a.data,
          } as WintSuperkollAPIModelAdvisor.AttachmentReference)
      ),
    });
  };

  return (
    <DocumentationLogCreateForm
      ref={ref}
      validationSchema={validationSchema}
      defaultValues={documentationLog}
      handleSubmit={handleFormSubmit}
      onFormValidationChange={onFormValidationChange}
    />
  );
};

export default forwardRef(DocumentationLogCreateFormContainer);
